<template>
  <CContainer fluid>
    <h3>Prospectos</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6" sm="6">
            <CInput 
              label="Buscar: " 
              :value.sync="searchWord"
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="sm-6" sm="6">
            <CButton 
              color="success" 
              class="mt-4"
              :to="`${rootPath}/agregar`">
              <i class="bi bi-plus-circle h4 mr-2"></i>
              <span>Agregar</span>
            </CButton>
          </CCol>
        </CRow>

        <CDataTable
          hover
          class="table-hover-icons"
          :noItemsView="{ noItems: ' ' }"
          :responsive=true
          :fields="columns"
          :items="directories"
          :items-per-page="itemsPerPage"
          @row-clicked="(item, index, _columnName, e) => {
            // $router.push({ path: `${rootPath}/editar/${item.id_Directorio}` });
          }">
          <template #empresa="{item}">
            <td>
              <div>
                <h4><strong>{{ item.empresa }}</strong></h4>
              </div>
              <div>
                <i class="bi bi-postcard mr-1"></i>
                <span>{{ item.identificacion }}</span>
              </div>
              <div>
                <i class="bi bi-person-badge mr-1"></i>
                <span>{{ item.empleado }}</span>
              </div>
              <!-- <div>
                <CBadge :color="getColor(item.estado_Cliente)">
                  {{ getStatus(item.estado_Cliente) }}
                </CBadge>
              </div> -->
            </td>
          </template>
          <template #direccion="{item}">
            <td>
              <div>
                <i v-if="item.direccion" class="bi bi-geo-fill mr-2"></i>
                <span>{{ ifNullOrUndefinedReturnEmpty(item.direccion) }}</span>
              </div>
              <div>
                <span>{{ ifNullOrUndefinedReturnEmpty(item.direccion_Aux) }}</span>
              </div>
              <div>
                <CIcon name="cil-map" class="mr-1"/>
                <span>{{ ifNullOrUndefinedReturnEmpty(item.ciudad) }} - {{ ifNullOrUndefinedReturnEmpty(item.departamento) }}</span>
              </div>
            </td>
          </template>
          <template #informacion="{item}">
            <td>
              <div>
                <span>{{ item.ultima_Compra }}</span>
              </div>
            </td>
          </template>
          <template #acciones="{item}">
            <td class="d-flex">
              <div class="hover-actions">
                <a href="#" 
                  v-c-tooltip="'Editar'"
                  @click="() => {
                    $router.push({ path: `${rootPath}/editar/${item.id_Directorio}` });
                  }">
                  <CIcon name="cil-pencil" class="text-warning hover-icon mr-2"/>
                </a>
                <a href="#" 
                  v-c-tooltip="'Eliminar'"
                  @click="(e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    tryDelete(event, item.id_Directorio);
                  }">
                  <CIcon name="cil-trash" class="text-danger hover-icon mr-2"></CIcon>
                </a>
              </div>

              <a href="#"
                class="text-decoration-none"
                @click="toggleDocument($event, item)">
                <CIcon 
                  class="text-dark"
                  :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'">
                </CIcon>
              </a>
            </td>
          </template>
    
          <template #details="{item}">
            <CCollapse class="mb-2" :show="item._toggled">
              <div class="d-flex justify-content-end">
                <a href="#" 
                  class="m-2" 
                  v-c-tooltip="'Seguimientos'"
                  @click="(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    openRightSideBar(event, item)
                  }">
                  <i class="bi bi-list-check text-s3purple h4"></i>
                </a>
                <a href="#" 
                  class="mr-2"
                  v-c-tooltip="'Cargar archivo'"
                  @click="openPanelUploadAttachments($event, item.id_Directorio)">
                  <Icon icon="fluent:document-arrow-up-20-regular" class="text-s3fuchsia h2" />
                </a>
                <a href="#" 
                class="mr-2"
                  v-c-tooltip="'Archivos adjuntos'"
                  @click="openPanelAttachments($event, item.id_Directorio)">
                  <Icon icon="teenyicons:attachment-outline" class="text-s3brown h4 mt-1" />
                </a>
              </div>
              <CCol col="12" sm="6" class="d-inline-block align-top">
                <div>

                </div>
              </CCol>
              <CCol col="12" sm="6" class="d-inline-block align-top">
                <!-- <div>
                  <i class="bi bi-bag-check mr-2"/>
                  <span>{{item.cantidad_VentasAnio}}</span>
                </div>
                <div>
                  <i class="bi bi-cash-coin mr-2"/>
                  <span>{{formatter.format(item.valor_VentasAnio ? item.valor_VentasAnio : 0, 0)}}</span>
                </div>
                <div>
                  <i class="bi bi-cart-check mr-2"></i>
                  <span>{{item.ultima_Compra ? moment(item.ultima_Compra).format("DD/MM/YYYY") : ""}}</span>
                </div> -->
              </CCol>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)"
        />  
      </CCardBody>

      <LoadingCover spinner="blocks" :size="32" v-show="loading" />
    </CCard>
  </CContainer>
</template>

<style scoped>
  @import "../../../../assets/css/table-hover-actions.css";
</style>

<script>
  import moment from "moment";
  import { Icon } from "@iconify/vue2";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import { formatter } from "@/general";
  import { dataGridDirectorio } from "@/api";

  // ********
  const columns = [
    { 
      key: "empresa", 
      label: "Empresa", 
      _style: "text-align: center;"
    },
    {
      key: "direccion",
      label: "Dirección",
      _style: "text-align: center;"
    },
    {
      key: "informacion",
      label: "Informacion",
      _style: "text-align: center;"
    },
    { 
      key: "acciones", 
      label: "",
      _style: "text-align: center;"
      // _style: { textAlign: 'center' },
      // _props: { className: 'text-center' }
    }
  ]

  export default {
    name: "ProspectList",
    data() {
      return {
        formatter,
        rootPath: "",
        loading: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        columns,
        directories: []
      }
    },
    components: {
      LoadingCover,
      Icon
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true;
        this.searchWord = search;

        try {
          const { count, results } = await dataGridDirectorio(this, page, search, "prospecto");

          this.directories = results;
          this.pageCount = parseInt(count / this.itemsPerPage);
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          } 
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          });
        } finally{
          this.loading = false;
        }
      },
      ifNullOrUndefinedReturnEmpty(value){        
        return value ? value : ''
      },
      toggleDocument(e, item){
        e.preventDefault();
        e.stopPropagation();
        
        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
    },
    setup() {
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      this.getData(this.page)
    }
  }
</script>
